import { TinyDropdownMenu, Toolbar } from '@octopus-do/octopus-storybook'
import {
  Clipboard,
  Clone,
  EllipsisVertical,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { forwardRef } from 'react'

// Key the menu reports to Toolbar.Root; the picked item follows it.
export const MORE_MENU_ID = 'more'

const Content: React.FC = () => (
  <TinyDropdownMenu.Group>
    <TinyDropdownMenu.Button icon={Clone} id="duplicate" label="Duplicate" />
    <TinyDropdownMenu.Button icon={Clipboard} id="paste" label="Paste" />
  </TinyDropdownMenu.Group>
)

// The menu closes on Paste, so the button carries the loader while the
// clipboard is read and applied.
const Trigger = forwardRef<HTMLButtonElement, { loading: boolean }>(
  ({ loading }, ref) => {
    const { active, toggle } = TinyDropdownMenu.useTrigger()

    return (
      <Toolbar.DropdownButton
        active={active}
        icon={EllipsisVertical}
        loading={loading}
        onClick={toggle}
        ref={ref}
        tooltip="More"
      />
    )
  }
)

interface Props {
  pasting: boolean
}

export const MoreMenu: React.FC<Props> = ({ pasting }) => {
  const { onClick } = Toolbar.useToolbarClick(MORE_MENU_ID)

  return (
    <TinyDropdownMenu.Root content={Content} onClick={onClick}>
      <Trigger loading={pasting} />
    </TinyDropdownMenu.Root>
  )
}
